import { asyncService } from '../utils/asyncService';
import { notificateOperationsEndpoint } from './endpoints';
import axios from 'axios';


const postNotificate = async (setError, notificate, authorized) => {
    try {
        await asyncService((params) => axios.post(notificateOperationsEndpoint(), notificate, {
            headers: {
                Authorization: `Bearer ${authorized.jwt.access_token}`
            },
            params
        }));
    } catch (error) {
        console.log(error)
        setError(error);
    }
};

export default postNotificate;